module.exports = "/images/chat.png?dd35ba589d5436edd3df20c990b68873";